<template>
  <a-layout>
    <the-header />
    <left-sider />
    <the-body />
  </a-layout>
</template>

<script>
import TheHeader from './TheHeader'
import LeftSider from './LeftSider'
import TheBody from './TheBody'

export default {
  components: {
    TheBody,
    TheHeader,
    LeftSider
  }
}
</script>
